import React from 'react';
import PropTypes from 'prop-types';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import isEmpty from 'lodash/isEmpty';

const CSSTransition = ({animation, className, timeout, children, component, style}) => {
    const transitionTimeout = isEmpty(timeout) ? {enter: 1, leave: 1} : timeout;
    return (
        <CSSTransitionGroup
            transitionName={animation} className={className} component={component} style={style}
            transitionEnterTimeout={transitionTimeout.enter}
            transitionLeaveTimeout={transitionTimeout.leave}>
            {children}
        </CSSTransitionGroup>
    );
};
CSSTransition.propTypes = {
    animation: PropTypes.string.isRequired,
    className: PropTypes.string,
    children: PropTypes.node,
    timeout: PropTypes.shape({
        enter: PropTypes.number.isRequired,
        leave: PropTypes.number.isRequired,
    }),
    component: PropTypes.string
};

export default CSSTransition;
